/*
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-12-03 16:18:37
 * @LastEditTime: 2023-06-28 14:29:59
 * @LastEditors: zhaoshuai
 */
let isPro = true;
let userInfo = localStorage.getItem("apply_userInfo") ? JSON.parse(localStorage.getItem("apply_userInfo")) : {};

const baseConf = {
    isPro: isPro, // 是否是生产环境
    wxFlag: 'cgft',
    examCode: userInfo.examCode ? userInfo.examCode : 'cgft',
    // wxAppid: 'wx706b79d4e1a1ca6e',
    // wxSecret: 'efe9ed82def614d25d43231393f0a8f6',
    // platform: '第十二届',
    webSource: 'cgft',
    baseUri: isPro ? 'www.cgftedu.com' : 'http://101.133.140.196:16000',
    productPackageId: isPro ? '1398943582255067138' : '1398943582255067138',
    // reqUrl: isPro ? 'http://47.103.158.90:16000' : 'http://101.133.140.196:16000'
    reqUrl: isPro ? 'http://www.cgftedu.com' : 'http://101.133.140.196:16000'


}

export default baseConf;